// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Wfrbj","buttons":"styles_buttons__1NbxL"};